/* eslint-disable @next/next/no-img-element */
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from '@emotion/styled';
import { Fonts, mediaQuery, Spacings } from '@styles/index';
import H1 from '@base/H1/H1';
import H3 from '@base/H3/H3';
import H4 from '@base/H4/H4';
import Paper from '@base/Paper/Paper';
import CircularLoader from '@base/CircularLoader/CircularLoader';
import Image from '@base/Image';
import useWindowSize from '@hooks/useWindowSize';
import { getCMSDataDescription, getisLoading } from '@selectors/careers';

const Wrapper = styled(Paper)`
  grid-column: span 24;
  display: flex;
  padding: ${Spacings.SPACING_0B};
  justify-content: center;
  background: var(--color-i-blue-6);
`;
const Frame = styled.div`
  width: 944px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: ${Spacings.SPACING_0B};
  margin-top: ${Spacings.SPACING_30B};
  margin-bottom: ${Spacings.SPACING_30B};
  ${mediaQuery.uptoTablet} {
    width: 90%;
    margin: ${Spacings.SPACING_15B} ${Spacings.SPACING_5B};
  }
  ${mediaQuery.uptoMobile} {
    margin: ${Spacings.SPACING_15B} ${Spacings.SPACING_4B};
    width: 100%;
    height: auto;
  }
`;

const TitleDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 600px;
  height: 126px;
  ${mediaQuery.uptoMobile} {
    width: 345px;
    height: auto;
  }
`;

const Headline = styled(H1)`
  font-size: 40px;
  text-align: center;
  margin-bottom: ${Spacings.SPACING_2B};
  line-height: 120%;
  ${mediaQuery.uptoMobile} {
    line-height: 150%;
    margin-bottom: ${Spacings.SPACING_1B};
    font-size: ${Fonts.H4};
  }
`;
const SubText = styled(H3)`
  text-align: center;
  line-height: 150%;
  font-weight: ${Fonts.REGULAR};
  ${mediaQuery.uptoMobile} {
    width: 274px;
    font-size: ${Fonts.SMALL};
  }
`;

const IconsParentDiv = styled.div`
  display: grid;
  grid-column-gap: ${Spacings.SPACING_16B};
  grid-row-gap: ${Spacings.SPACING_21B};
  grid-template-columns: repeat(3, 1fr);
  width: 944px;
  margin-top: ${Spacings.SPACING_20B};
  ${mediaQuery.uptoTablet} {
    width: 95%;
    grid-column-gap: 0;
  }
  ${mediaQuery.uptoMobile} {
    grid-row-gap: ${Spacings.SPACING_10B};
    margin-top: ${Spacings.SPACING_15B};
    grid-template-columns: repeat(2, 1fr);
    width: 328px;
  }
`;

const IconDiv = styled.div`
  display: flex;
  width: 272px;
  flex-direction: row;
  align-items: center;
  padding: ${Spacings.SPACING_2} ${Spacings.SPACING_0B};
  ${mediaQuery.uptoTablet} {
    width: auto;
  }
  ${mediaQuery.uptoMobile} {
    width: 160px;
  }
`;
const IconTitle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: ${Spacings.SPACING_6B};
  padding: ${Spacings.SPACING_0B};
  ${mediaQuery.uptoMobile} {
    margin-left: ${Spacings.SPACING_2B};
  }
`;
const IconTitletext = styled(H1)`
  font-size: 40px;
  line-height: 120%;
  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.H4};
  }
`;
const IconTitleSubtext = styled(H4)`
  font-weight: ${Fonts.REGULAR};
  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.SMALL};
  }
`;
const Text = styled.span`
  color: var(--color-i-green);
`;

const Icon = ({ data }) => {
  const { isMobile } = useWindowSize();
  return (
    <IconDiv>
      <Image
        src={data.url}
        alt={data.name}
        height={isMobile ? 56 : 80}
        width={isMobile ? 56 : 80}
      />
      <IconTitle>
        <IconTitletext>
          {data.value}
          <Text>+</Text>
        </IconTitletext>
        <IconTitleSubtext>{data.name}</IconTitleSubtext>
      </IconTitle>
    </IconDiv>
  );
};
const Stats = () => {
  const [iconsLinks, setIconsLinks] = useState([]);
  const isLoading = useSelector(getisLoading);
  const cmsData = useSelector(getCMSDataDescription);

  useEffect(() => {
    if (cmsData.length > 0) setIconsLinks(JSON.parse(cmsData).stats);
  }, [cmsData]);

  return (
    <Wrapper>
      <Frame>
        <TitleDiv>
          <Headline>We’re only getting started</Headline>
          <SubText>
            Unacademy is dedicated to its mission and is at the forefront of
            revolutionising the ed-tech space in India.
          </SubText>
        </TitleDiv>
        {isLoading && <CircularLoader />}
        <IconsParentDiv>
          {iconsLinks.map((icon) => (
            <Icon data={icon} key={icon.url} />
          ))}
        </IconsParentDiv>
      </Frame>
    </Wrapper>
  );
};

export default Stats;
